function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignatureLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.646 4.76241L15.3339 1.45029C14.5979 0.714261 13.5552 0.284912 12.5125 0.284912H7.29894C6.25624 0.284912 5.21353 0.714261 4.4775 1.45029L1.16538 4.76241C0.42935 5.49844 0 6.54115 0 7.58385V12.736C0 13.7788 0.42935 14.8215 1.16538 15.5575L5.15219 19.5443C5.39754 19.7896 5.52021 20.0963 5.52021 20.4643V22.0591C5.52021 22.9791 6.25624 23.7151 7.17627 23.7151H12.4511C13.3712 23.7151 14.1072 22.9791 14.1072 22.0591V20.5257C14.1072 20.219 14.2299 19.851 14.4752 19.6056L18.5847 15.5575C19.3207 14.8215 19.7501 13.7788 19.7501 12.736V7.58385C19.8727 6.54115 19.4434 5.55978 18.646 4.76241ZM15.6406 12.0614C15.6406 12.6134 15.4566 13.1041 15.0886 13.5334L13.4938 15.2508C12.9418 15.8028 12.8191 16.6615 13.1258 17.3976L14.0459 19.667H5.88822L6.80826 17.3976C7.11494 16.6615 6.93093 15.8642 6.44024 15.2508L4.84552 13.5334C4.4775 13.1654 4.29349 12.6134 4.29349 12.0614V8.31988C4.29349 7.76786 4.4775 7.27718 4.84552 6.90916L6.62425 4.88509C7.0536 4.45574 7.60562 4.14906 8.21898 4.14906H11.7151C12.3285 4.14906 12.8805 4.3944 13.3098 4.88509L15.1499 6.90916C15.5179 7.27718 15.7019 7.8292 15.7019 8.38122V12.0614H15.6406Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.7705,
    y: 0.5,
    width: 2,
    height: 23,
    fill: "#BFD3F3",
    style: {
      fill: "#BFD3F3",
      fill: "color(display-p3 0.7490 0.8288 0.9529)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignatureLogo);
export default __webpack_public_path__ + "static/media/signature-logo.d6ecf3633a229835c7a3d581bfee5905.svg";
export { ForwardRef as ReactComponent };